<div class="application-conversation section no-padding">
  <div class="section-header">
    <div class="inline">
      <h2>
        {{ 'pages.serviceProcessing.applicationConversation.title' | translate }}
      </h2>
      <app-tooltip text="applicationConversation" />
    </div>
    <div class="actions">
      @if (shouldRenderRequestAdditionalInfoButton) {
        <button class="secondary" (click)="requestAdditionalInfo()">
          {{ 'pages.serviceProcessing.requestAdditionalInfo' | translate }}
        </button>
      }
      <button class="secondary" (click)="addClientNote()">
        {{ 'pages.serviceProcessing.addClientNote' | translate }}
      </button>
    </div>
  </div>
  <div class="content">
    <div class="table-header">
      <div class="inline">
        <p>
          {{ 'pages.serviceProcessing.applicationConversation.archive' | translate }}
        </p>
        <app-tooltip [marginBottom]="false" text="applicationConversationLna" />
      </div>
      <div class="inline">
        <p>
          {{ 'pages.serviceProcessing.applicationConversation.client' | translate }}
        </p>
        <app-tooltip [marginBottom]="false" text="applicationConversationClient" />
      </div>
    </div>
    <div class="messages-wrapper">
      @for (message of conversationList; track message.id) {
        <div class="message-row">
          <div class="message-row-wrapper" [ngClass]="[message.type]">
            @if (message.type !== 'Rescheduled') {
              <div class="message backoffice-message">
                <div class="message-top-row">
                  <div class="message-header">
                    <p class="message-title">
                      {{ message.createdByUser?.fullName }}
                    </p>
                    <p class="message-date">
                      {{ formatDatetime(message.createdOn, false) }}
                    </p>
                  </div>
                  @if (message.type !== 'RequestAdditionalInformation') {
                    <button class="link edit-btn" (click)="editMessage(message)">
                      <img src="assets/images/edit-icon.svg" alt="edit icon" />
                      {{ 'components.table.edit' | translate }}
                    </button>
                  }
                </div>
                <p class="message-text">{{ message.backofficeText }}</p>
                @if (message.backofficeFiles && message.backofficeFiles.length) {
                  <div class="file-wrapper">
                    <app-file-upload
                      [isEditMode]="false"
                      [existingFiles]="message.backofficeFiles || []"
                      [type]="communicationFileTypeFrontoffice"
                      [associatedEntityId]="message.id"
                      [isSubmitting]="false" />
                  </div>
                }
              </div>
            }
            @if (message.frontofficeText) {
              <div class="reply message">
                <div class="message-top-row">
                  <div class="message-header">
                    <p class="message-title">
                      {{ application.client.name }}
                      {{ application.client.surname }}
                    </p>
                    <p class="message-date">
                      {{ formatDatetime(message.type === 'Rescheduled' ? message.createdOn : message.frontofficeTextCreatedOn, false) }}
                    </p>
                    @if (!message.isReadByBackoffice) {
                      <div class="message-unread-indicator"></div>
                    }
                  </div>
                </div>
                <p class="message-text" [innerHTML]="message.frontofficeText"></p>
                @if (message.frontofficeFiles.length) {
                  <div class="file-wrapper">
                    <app-file-upload
                      [isEditMode]="false"
                      [existingFiles]="message.frontofficeFiles || []"
                      [type]="communicationFileTypeFrontoffice"
                      [associatedEntityId]="message.id"
                      [isSubmitting]="false" />
                  </div>
                }

                @if (!message.isReadByBackoffice) {
                  <button class="button-link mark-as-read" (click)="markAsRead(message.id)">
                    <img src="assets/images/double-check.svg" alt="view" />
                    {{ 'components.table.markAsRead' | translate }}
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<app-add-app-client-note-modal
  [isOpen]="isAddClientNoteModalOpen"
  [application]="application"
  (cancel)="isAddClientNoteModalOpen = false"
  (update)="onMessageSaved($event)" />
<app-add-app-client-note-modal
  [isOpen]="isEditClientNoteModalOpen"
  [application]="application"
  [note]="this.editNote"
  (cancel)="isEditClientNoteModalOpen = false"
  (update)="onMessageSaved($event)" />
<app-request-additional-info-modal
  [isOpen]="isRequestAdditionalInfoModalOpen"
  [application]="application"
  [tooltipText]="'requestAppAdditionInfoBackoffice'"
  [modalTitle]="'components.requestAdditionalNotes.requestTitle'"
  (cancel)="isRequestAdditionalInfoModalOpen = false"
  (update)="onMessageSaved($event)" />
